import { render, staticRenderFns } from "./EventsModal.vue?vue&type=template&id=f3a94452&lang=pug"
import script from "./EventsModal.vue?vue&type=script&lang=js"
export * from "./EventsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports